import { Children, FC, ReactNode, useState } from 'react';
import { Box } from '@chakra-ui/react';
import KeenSlider, { TOptions } from 'keen-slider';
import { CbCarouselHeader } from './CbCarouselHeader';
import { CbFullWidthContainer } from '../CbFullWidthContainer';
import { CbCarouselTrack } from '../CbCarouselTrack';
export interface CbCarouselProps {
  fillTrack?: boolean;
  hasTrackBackground?: boolean;
  heading?: string | ReactNode;
  isFullView?: boolean;
  maxWidth?: string | {};
  overrideStyles?: string;
  options?: TOptions;
  children?: ReactNode;
}
const defaultMaxWidth = {
  base: '78%',
  sm: '88%',
  lg: '100%'
};
export const CbCarousel: FC<CbCarouselProps> = ({
  fillTrack,
  hasTrackBackground,
  heading,
  isFullView = true,
  maxWidth = defaultMaxWidth,
  overrideStyles,
  options,
  children
}) => {
  const [slider, setSlider] = useState<KeenSlider | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideChanged = slider => {
    setCurrentSlide(slider.details().relativeSlide);
  };
  const defaultOptions = {
    slidesPerView: 1,
    spacing: 16,
    breakpoints: {
      '(min-width: 660px)': {
        slidesPerView: 2
      },
      '(min-width: 992px)': {
        slidesPerView: 3,
        spacing: 24
      }
    },
    slideChanged
  };
  const carouselOptions = {
    ...defaultOptions,
    ...options
  };
  const getSlider = slider => {
    setSlider(slider);
  };
  const handlePrevClick = () => {
    slider?.prev();
  };
  const handleNextClick = () => {
    slider?.next();
  };
  const arrayChildren = Children.toArray(children);
  const hasArrows = slider && slider.details().slidesPerView < arrayChildren.length ? true : false;
  const prevDisabled = currentSlide === 0;
  const nextDisabled = slider && currentSlide >= arrayChildren.length - slider.details().slidesPerView;
  const carouselTrack = <Box maxWidth={maxWidth}>
      <CbCarouselTrack fillTrack={fillTrack} getSlider={getSlider} isFullView={isFullView} options={carouselOptions} overrideStyles={overrideStyles}>
        {children}
      </CbCarouselTrack>
    </Box>;
  return <Box data-sentry-element="Box" data-sentry-component="CbCarousel" data-sentry-source-file="CbCarousel.tsx">
      <CbCarouselHeader hasArrows={hasArrows} heading={heading} prevDisabled={prevDisabled} nextDisabled={nextDisabled || false} onPrevClick={handlePrevClick} onNextClick={handleNextClick} marginBottom={hasTrackBackground ? 3 : 6} data-sentry-element="CbCarouselHeader" data-sentry-source-file="CbCarousel.tsx" />

      {hasTrackBackground ? <CbFullWidthContainer>{carouselTrack}</CbFullWidthContainer> : carouselTrack}
    </Box>;
};